import type { ProfileUpdate } from '@cocoonspace/api'

import { removeUndefined } from '~/lib/remove-undefined'
import type { GeneralInfoFormData } from './use-profile-form.hook'

const toProfileImagePath = (value: string | undefined) => {
	if (!value) return value

	try {
		const url = new URL(value)
		if (url.hostname !== 'storage.googleapis.com') return value

		const [, bucket, ...objectPath] = url.pathname.split('/')
		if (!bucket || objectPath.length === 0) return value

		return decodeURIComponent(objectPath.join('/'))
	} catch {
		return value
	}
}

export const toProfileUpdatePayload = ({
	avatarPreview: _avatarPreview,
	bannerPreview: _bannerPreview,
	logoPreview: _logoPreview,
	backgroundPreview: _backgroundPreview,
	externalLinks,
	...data
}: GeneralInfoFormData): ProfileUpdate => ({
	...removeUndefined(data),
	avatarUrl: toProfileImagePath(data.avatarUrl),
	styles: {
		...data.styles,
		bannerImageUrl: toProfileImagePath(data.styles.bannerImageUrl),
		logoUrl: toProfileImagePath(data.styles.logoUrl),
		backgroundImageUrl: toProfileImagePath(data.styles.backgroundImageUrl),
	},
	externalLinks,
})
